import { makeFrameworkTypesQuickFetchKey, makeFrameworkTypesFetchUrl } from './cacheKeys';
import { withQuickFetch } from './withQuickFetch';
export const fetchFrameworkTypes = ({
  family,
  httpClient
}) => withQuickFetch({
  requestName: makeFrameworkTypesQuickFetchKey({
    family
  }),
  baseFetch: () => httpClient.get(makeFrameworkTypesFetchUrl({
    family
  }))
});